import React, { useState } from 'react'
import { Button, Dialog, DialogContent, Grid, IconButton, TextField, Typography, DialogTitle, FormControl, InputLabel, OutlinedInput, InputAdornment, MenuItem, Select } from '@mui/material'
import DisabledByDefaultIcon from '@mui/icons-material/DisabledByDefault';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import axios from 'axios';
import { toast } from 'react-toastify';
import { Navigate } from 'react-router-dom';
import { CLIENT_NAME } from '../config/clientInfo';

function UserLogin({ setHandleOpen, handelOpen, onLogin, initialUsername = '', renewSession = false }) {

    const [branch, setBranch] = useState('');
    const [username, setUsername] = useState(initialUsername);
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = React.useState(false);
    const handleClickShowPassword = () => setShowPassword((show) => !show);

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    const handleMouseUpPassword = (event) => {
        event.preventDefault();
    };
    const [error, setError] = useState('');
    const [signingIn, setSigningIn] = useState(false);

    const handleSignUp = async (e) => {
        e.preventDefault();
        if (signingIn) return;
        setSigningIn(true);
        setError('');
        try {
            // Replace with your backend API URL for signing up
            const response = await axios.post('https://serverkf.ccsoftwares.com/Users/loginUser', {
                username,
                password,
                branch
            });
            //console.log(response);

            if (typeof response.data.user?.username !== 'string' || !response.data.user.username.trim() || ![1, 2].includes(Number(response.data.user.role))) {
                throw new Error('The server did not return a valid login session.');
            }
            const paws = {
                username: response.data.user.username,
                role: Number(response.data.user.role),
                shop: response.data.user.shop,
            };
            localStorage.setItem('AutoParts', JSON.stringify(paws));
            toast.success(renewSession ? 'Signed in. You can retry saving or printing your bill.' : 'Signed in successfully.');
            setError('');

            setHandleOpen(false)
            setPassword('');
            if (onLogin) onLogin(paws);
            else window.location.reload();

        } catch (err) {
            const message = err.response?.data?.error || err.message || 'Unable to sign in. Please try again.';
            setError(message);
            toast.error(message);
        } finally {
            setSigningIn(false);
        }
    };

    const handleClose = () => {
        setHandleOpen(false)
    }

    const Signup = () => {
        Navigate('Signup')
    }
    return (
        <>
            <Dialog
                aria-labelledby="customized-dialog-title"
                open={handelOpen}
            >
                <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    sx={{
                        position: 'absolute',
                        right: 25,
                        top: 20,
                        height: 50,
                        width: 50,
                        color: (theme) => theme.palette.grey[200],
                    }}
                >
                    <DisabledByDefaultIcon sx={{ color: '#000000', fontSize: '40px' }} />
                </IconButton>
                <DialogTitle sx={{
                    color: '#000000',
                    fontSize: '35px',
                    fontFamily: 'sans-serif',
                    fontWeight: '1000',
                    display: "flex",
                    justifyContent: "center",
                    alignContent: 'center'
                }}>{renewSession ? 'Sign in to continue billing' : CLIENT_NAME}</DialogTitle>
                <DialogContent >
                    <Grid container spacing={4}>
                        {renewSession && <Grid item xs={12}><Typography color="text.secondary">
                            Your login needs to be renewed. Your bill and its items are still here. Sign in again, then retry your action.
                        </Typography></Grid>}
                        <Grid item md={12} sx={{ display: 'flex', justifyContent: 'center', paddingTop: '10px' }}>
                        </Grid>

                        <Grid item md={12}>
                            <TextField id="outlined-basic" label="Username" variant="outlined" size='large' fullWidth value={username} disabled={renewSession && Boolean(initialUsername)}
                                onChange={(e) => setUsername(e.target.value)} />
                        </Grid>
                        <Grid item md={12}>
                            <FormControl variant="outlined" fullWidth>
                                <InputLabel htmlFor="outlined-adornment-password">Password</InputLabel>
                                <OutlinedInput
                                    id="outlined-adornment-password"
                                    fullWidth
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    type={showPassword ? 'text' : 'password'}
                                    endAdornment={
                                        <InputAdornment position="end">
                                            <IconButton
                                                aria-label="toggle password visibility"
                                                onClick={handleClickShowPassword}
                                                onMouseDown={handleMouseDownPassword}
                                                onMouseUp={handleMouseUpPassword}
                                                edge="end"
                                            >
                                                {showPassword ? <VisibilityOff /> : <Visibility />}
                                            </IconButton>
                                        </InputAdornment>
                                    }
                                    label="Password"
                                />
                            </FormControl>
                        </Grid>
                        {error && <Grid item xs={12}><Typography color="error" role="alert">{error}</Typography></Grid>}
                        <Grid item md={12} xs={12}>
                            <center>
                                <Button
                                    variant="contained"
                                    size='large'
                                    sx={{
                                        width: '70%',
                                        fontFamily: 'sans-serif',
                                    }}
                                    type="submit"
                                    disabled={signingIn || !username.trim() || !password}
                                    onClick={handleSignUp}
                                >
                                    {signingIn ? 'Signing in…' : 'Login'}
                                </Button>

                            </center>
                        </Grid>
                    </Grid>
                </DialogContent>
            </Dialog >
        </>

    )
}

export default UserLogin
